import React from 'react';

import { MaskedInput } from 'reactApp/components/Forms/MaskedInput';
import { Input, InputProps } from 'reactComponents/Input/Input';
import { InputNumber } from 'reactComponents/InputNumber/InputNumber';

import { BasicField } from './_BasicField';

type Props = InputProps &
    Omit<React.HTMLProps<HTMLInputElement>, 'onChange'> & {
        label?: string;
        name: string;
        type?: 'number' | undefined;
        onChange?: (event: any, props: Props) => void;
        min?: number;
        max?: number;
        control?: any;
        cleanMaskedValue?: boolean;
        maskPattern?: 'phone' | 'ip' | 'ipWithMask';
        maskOptions?: any;
        mask?: any;
        noSystemSpinner?: any;
    };

export const FieldInput = ({
    label,
    name,
    type,
    onChange,
    min,
    max,
    control,
    ...otherInputProps
}: Props) => {
    const isMaskedInput =
        otherInputProps.maskPattern ||
        otherInputProps.maskOptions ||
        otherInputProps.mask;

    if (!control) {
        if (isMaskedInput) {
            control = MaskedInput;
        } else {
            control =
                type === 'number' && !otherInputProps.noSystemSpinner
                    ? InputNumber
                    : Input;
        }
    } else if (control === Input && isMaskedInput) {
        control = MaskedInput;
    }

    return (
        // @ts-ignore
        <BasicField
            {...{
                label,
                name,
                type,
                onChange,
                min,
                max,
                control,
                ...otherInputProps,
            }}
        />
    );
};
